/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveApiV1LedgersLedgerCanisterIdGetRequest = {
  ledgerCanisterId: string;
};

/** @internal */
export const RetrieveApiV1LedgersLedgerCanisterIdGetRequest$inboundSchema:
  z.ZodType<
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type RetrieveApiV1LedgersLedgerCanisterIdGetRequest$Outbound = {
  ledger_canister_id: string;
};

/** @internal */
export const RetrieveApiV1LedgersLedgerCanisterIdGetRequest$outboundSchema:
  z.ZodType<
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest$Outbound,
    z.ZodTypeDef,
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace RetrieveApiV1LedgersLedgerCanisterIdGetRequest$ {
  /** @deprecated use `RetrieveApiV1LedgersLedgerCanisterIdGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest$inboundSchema;
  /** @deprecated use `RetrieveApiV1LedgersLedgerCanisterIdGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest$outboundSchema;
  /** @deprecated use `RetrieveApiV1LedgersLedgerCanisterIdGetRequest$Outbound` instead. */
  export type Outbound =
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest$Outbound;
}

export function retrieveApiV1LedgersLedgerCanisterIdGetRequestToJSON(
  retrieveApiV1LedgersLedgerCanisterIdGetRequest:
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest,
): string {
  return JSON.stringify(
    RetrieveApiV1LedgersLedgerCanisterIdGetRequest$outboundSchema.parse(
      retrieveApiV1LedgersLedgerCanisterIdGetRequest,
    ),
  );
}

export function retrieveApiV1LedgersLedgerCanisterIdGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  RetrieveApiV1LedgersLedgerCanisterIdGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      RetrieveApiV1LedgersLedgerCanisterIdGetRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'RetrieveApiV1LedgersLedgerCanisterIdGetRequest' from JSON`,
  );
}
